(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-accordion-01"] && !Shopify.designMode) return;
  try {
    
  class YGAccordion01 extends HTMLElement {
    #sectionEl;
    constructor() {
      super();
      this.currentStepIndex = 0;
    }

    get $sectionEl() {
      if (this.#sectionEl) return this.#sectionEl
      let isMobile = window.innerWidth < 699;

      this.#sectionEl = {
        'accordionList': this.querySelectorAll('.yg-process-steps-item'),
        'progressBars': this.querySelectorAll('.yg-process-steps-progress-bar'),
        'controls': isMobile ? this.querySelectorAll('.yg-process-steps-content-media') : this.querySelectorAll('.yg-process-steps-media')
      }

      return this.#sectionEl
    }

    connectedCallback() {
      document.addEventListener('YG:dropdown-open', (event) => {
        if (event.detail.id) {
          this.currentStep(event.detail.id);
        }
      });
      document.addEventListener('YG:progress-end', (event) => {
        if (event.detail.id) {
          this.nextStep(event.detail.id);
        }
      });
    }

    nextStep(id) {
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          let indexNext = i == this.$sectionEl['accordionList'].length - 1 ? 0 : i + 1;
          this.currentStepIndex = indexNext;
        }
      });
      
      if (!this.isCurrentStep(id)) {
        return;
      }
      this.$sectionEl['accordionList'][this.currentStepIndex]?.openDropdown();
    }

    currentStep(id) {
      if (!this.isCurrentStep(id)) {
        return;
      }
      this.setActiveControl(id);
      this.startProgressForId(id);
      this.playVideo(id);
    }

    isCurrentStep(id) {
      let isCurrentStep = false;
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          isCurrentStep = true;
        }
      });
      return isCurrentStep;
    }

    getEffectiveId(id) {
      let isMobile = window.innerWidth < 699;
      if (isMobile) {
        return id.replace('steps-item-', 'steps-item-mobile-');
      }
      return id;
    }

    setActiveControl(id) {
      this.$sectionEl['controls'].forEach((item) => {
        if (item.getAttribute('data-id') === id) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    startProgressForId(id) {
      this.$sectionEl['progressBars']?.forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          this.currentStepIndex = i;
          item.startProgress();
        } else {
          item.stopProgress();
        }
      });
    }

    getVideoById(id) {
      let videoEl = null;
      this.$sectionEl['controls'].forEach((item) => {
        if (item.querySelector('yg-video')?.getAttribute('data-id') === id) {
          videoEl = item.querySelector('yg-video');
        }
      });
      return videoEl;
    }

    pauseAllVideos() {
      this.$sectionEl['controls'].forEach((item) => {
        const videoEl = item.querySelector('yg-video');
        if (videoEl) {
          videoEl.pauseVideo();
        }
      });
    }

    playVideo(id) {
      let effectiveId = this.getEffectiveId(id);
      this.pauseAllVideos();
      const videoEl = this.getVideoById(effectiveId);
      if (videoEl) {
        videoEl.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-accordion-01')) {
    window.customElements.define('yg-accordion-01', YGAccordion01);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-02"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tab"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    class YGTab extends YGUtils {
      constructor() {
        super()
        this.$btnList = this.btnList
        this.$itemList = this.itemList
      }
      get btnList () {
        if (!this.$btnList) {
          this.$btnList = this.querySelectorAll('.yg-tab-item')
        }
        return this.$btnList
      }
      get itemList () {
        if (!this.$itemList) {
          this.$itemList = this.querySelectorAll('.yg-tab-content')
        }
        return this.$itemList
      }

      handClick (e, i) {
          this.$itemList.forEach(item => item.classList.remove('active'))
          this.$btnList.forEach(item => item.classList.remove('active'))
          this.$btnList[i].classList.add('active')
          this.$itemList[i].classList.add('active')
          
          // 移动端时滚动到视口中心
          if (window.innerWidth <= 699) {
            this.$btnList[i].scrollIntoView({
              behavior: 'smooth',
              inline: 'center',
              block: 'nearest'
            });
          }
      }
      // 移动端详情盒子点击处理
      initDetailBoxMobile () {
        const detailBoxes = this.querySelectorAll('.yg-small-detail-box');
        detailBoxes.forEach(box => {
          box.addEventListener('click', (e) => {
            // 移动端
            if (window.innerWidth <= 699) {
              e.stopPropagation();
              // 移除所有active
              detailBoxes.forEach(item => item.classList.remove('active'));
              // 添加active
              box.classList.add('active');
              document.body.style.overflow = 'hidden';
            }
          });
        });

        const closeBtns = this.querySelectorAll('.yg-detail__close');
        closeBtns.forEach(btn => {
          btn.addEventListener('click', (e) => {
            // 移动端
            if (window.innerWidth <= 699) {
              e.stopPropagation();
              // 找到对应的yg-small-detail-box并移除active
              const parentBox = btn.closest('.yg-small-detail-box');
              if (parentBox) {
                parentBox.classList.remove('active');
                document.body.style.overflow = 'unset';
              }
            }
          });
        });
      }
      connectedCallback () {
        // 初始化时给第一项添加active类
        if (this.$btnList.length > 0) {
          this.$btnList[0].classList.add('active');
        }
        if (this.$itemList.length > 0) {
          this.$itemList[0].classList.add('active');
        }
        
        this.$btnList.forEach(($item, i) => $item.addEventListener('click', (e) => this.handClick(e, i)))
        
        // 移动端详情盒子点击处理
        this.initDetailBoxMobile();
      }


    }
    if (!window.customElements.get('yg-tab')) {
      window.customElements.define('yg-tab', YGTab)
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-time"] && !Shopify.designMode) return;
  try {
    
    class YGTime extends HTMLElement { 
        constructor() {
            super();
            this.initSwiper();
        }
        initSwiper() { 
            const thumb = new Swiper(this.querySelector('.yg-right-image'), {
                slidesPerView: 1,
                spaceBetween: 10,
                navigation: {
                    nextEl: this.querySelector('.yg-swiper-button-next.hide-pc'),
                    prevEl: this.querySelector('.yg-swiper-button-prev.hide-pc'),
                },
            });
            
            const paginationEl = this.querySelector('.swiper-pagination');
            const main = new Swiper(this.querySelector('.yg-left-content'), {
                slidesPerView: 1,
                spaceBetween: 10,
                navigation: {
                    nextEl: this.querySelector('.yg-swiper-button-next.hide-mobile'),
                    prevEl: this.querySelector('.yg-swiper-button-prev.hide-mobile'),
                },
                pagination: {
                    el: paginationEl,
                    clickable: true,
                    renderBullet: function (index, className) {
                        // 自定义 bullet 结构，嵌套进度条 div
                        return '<span class="' + className + '"><div class="yg-progress-bar"></div></span>';
                    },
                },
                thumbs: {
                    swiper: thumb,
                },
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: false,
                }
            });

            thumb.on('slideChange', function () { 
                main.slideTo(thumb.realIndex);
            });

            // 动态设置 grid-template-columns 基于 bullet 数量
            const bullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
            if (bullets.length > 0) {
                paginationEl.style.gridTemplateColumns = `repeat(${bullets.length}, 1fr)`;
            }
        }
    }
    customElements.define('yg-time', YGTime);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", ()=>{
    class YGVideoList01 extends HTMLElement {
        constructor() {
            super()
            this.playbackMode = this.getAttribute('data-playback-mode')
            this.slideItems = this.querySelectorAll('.yg-slide-item')
        }
        connectedCallback() {
            if (this.playbackMode === 'hover' && window.innerWidth > 1024) {
                this.initHoverPlayback()
            }
        }

        initHoverPlayback() {
            this.slideItems.forEach(item => {
                const videoEl = item.querySelector('yg-video')
                if (!videoEl) return

                item.addEventListener('mouseenter', () => {
                    requestAnimationFrame(() => {
                      if (videoEl.playVideo) {
                        videoEl.playVideo()
                      }
                    })
                })

                item.addEventListener('mouseleave', () => {
                    if (videoEl.pauseVideo) {
                        videoEl.pauseVideo()
                    }
                })
            })
        }
    }
    if (!window.customElements.get('yg-video-list-01')) {
        window.customElements.define('yg-video-list-01',YGVideoList01)
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list-02"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", ()=>{
    class YGVideoList02 extends HTMLElement {
        constructor() {
            super()
            this.pendingPlayIndex = null
            this.boundClickHandler = null
            this.autoAdvanceTimeout = null
            this.isInViewport = false
            this.viewportObserver = null
        }

        connectedCallback() {
          const swiperElement = this.querySelector('yg-swiper')
          this.swiper = swiperElement?.swiper
          this.defaultDelay = Number(this.dataset.defaultDelay) || 0
          this.slideCount = Number(this.dataset.slideCount) || 0

          if (!this.swiper) return

          this.bindSlideClick()
          this.initViewportObserver()

          this.swiper.on('slideChangeTransitionEnd', () => {
            this.handleSlideChanged()
          })
        }

        disconnectedCallback() {
          this.clearAutoAdvance()
          this.viewportObserver?.disconnect()
        }

        initViewportObserver() {
          if (this.viewportObserver) return

          this.viewportObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.target !== this) return

              if (entry.isIntersecting) {
                this.isInViewport = true
                this.handleSlideChanged()
              } else {
                this.isInViewport = false
                this.clearAutoAdvance()
                this.pauseAllVideos()
              }
            })
          }, {
            threshold: 0.35,
          })

          this.viewportObserver.observe(this)
        }

        getActiveSlide() {
          return this.swiper?.slides?.[this.swiper.activeIndex] || null
        }

        getSlideByRealIndex(slideIndex) {
          return Array.from(this.swiper?.slides || []).find((slide) => {
            return Number(slide.dataset?.swiperSlideIndex) === slideIndex
          }) || null
        }

        clearAutoAdvance() {
          if (this.autoAdvanceTimeout) {
            window.clearTimeout(this.autoAdvanceTimeout)
            this.autoAdvanceTimeout = null
          }
        }

        getSlideDelay(slide) {
          const slideDelay = Number(slide?.dataset?.swiperAutoplay)
          if (!Number.isNaN(slideDelay) && slideDelay > 0) {
            return slideDelay
          }
          return this.defaultDelay
        }

        scheduleNextSlide(slide) {
          this.clearAutoAdvance()

          if (!this.isInViewport) return

          const delay = this.getSlideDelay(slide)
          if (!delay || !this.slideCount) return

          const currentRealIndex = Number(slide?.dataset?.swiperSlideIndex)
          if (Number.isNaN(currentRealIndex)) return

          this.autoAdvanceTimeout = window.setTimeout(() => {
            if (!this.isInViewport) return
            const nextIndex = (currentRealIndex + 1) % this.slideCount
            this.selectSlide(nextIndex, true)
          }, delay)
        }

        pauseAllVideos() {
          this.querySelectorAll('.yg-slide-item').forEach((item) => {
            item.classList.remove('is-video-playing')
          })

          this.querySelectorAll('.swiper-slide yg-video').forEach((video) => {
            if (typeof video.pauseVideo === 'function') {
              video.pauseVideo()
            }
          })
        }

        playSlideVideo(slide) {
          if (!slide || !this.isInViewport) return

          const item = slide.querySelector('.yg-slide-item')
          const video = slide.querySelector('yg-video')

          if (video && typeof video.playVideo === 'function') {
            video.playVideo()
            item?.classList.add('is-video-playing')
          }
        }

        handleSlideChanged() {
          if (!this.isInViewport) return

          const activeSlide = this.getActiveSlide()
          if (!activeSlide) return

          if (this.pendingPlayIndex !== null) {
            const targetSlide = this.getSlideByRealIndex(this.pendingPlayIndex)
            if (targetSlide) {
              this.pauseAllVideos()
              this.playSlideVideo(targetSlide)
              this.scheduleNextSlide(targetSlide)
              this.pendingPlayIndex = null
              return
            }
          }

          this.pauseAllVideos()
          this.playSlideVideo(activeSlide)
          this.scheduleNextSlide(activeSlide)
          this.pendingPlayIndex = null
        }

        selectSlide(slideIndex, shouldPlay = false) {
          this.clearAutoAdvance()
          this.pendingPlayIndex = shouldPlay ? slideIndex : null

          this.swiper.slideToLoop(slideIndex)

          if (!shouldPlay) {
            requestAnimationFrame(() => {
              this.handleSlideChanged()
            })
          }
        }

        bindSlideClick() {
          if (this.boundClickHandler) return

          this.boundClickHandler = (event) => {
            const slide = event.target.closest('.swiper-slide')
            if (!slide || !this.contains(slide)) return

            const link = event.target.closest('a')
            if (link) return

            const clickedVideoButton = event.target.closest('.yg-video-button')
            const isActiveSlide = slide.classList.contains('swiper-slide-active')
            const slideIndex = Number(slide.dataset.swiperSlideIndex)

            if (Number.isNaN(slideIndex)) return

            if (clickedVideoButton) {
              if (isActiveSlide) {
                requestAnimationFrame(() => {
                  this.pauseAllVideos()
                  this.playSlideVideo(slide)
                  this.scheduleNextSlide(slide)
                })
                return
              }

              event.preventDefault()
              event.stopPropagation()
              this.selectSlide(slideIndex, true)
              return
            }

            if (!isActiveSlide) {
              this.selectSlide(slideIndex, false)
            }
          }

          this.addEventListener('click', this.boundClickHandler, true)
        }
    }
    if (!window.customElements.get('yg-video-list-02')) {
        window.customElements.define('yg-video-list-02',YGVideoList02)
    }
  })

  } catch(e) { console.error(e); }
})();
})();
